import request from '@/utils/request'

const url = '/home/search/'
const api = {
  getsearch (data) {
    return request({
      url: url + 'getsearch',
      method: 'post',
      data
    })
  },
  getGroupList (data) {
    return request({
      url: url + 'getGroupList',
      method: 'post',
      data
    })
  },
  mGet (data) {
    return request({
      url: url + 'mGet',
      method: 'post',
      data
    })
  },
  attrEsSearch (data) {
    return request({
      url: url + 'attrEsSearch',
      method: 'post',
      data
    })
  },
  esAttrFiltrate (data) {
    return request({
      url: url + 'esAttrFiltrate',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/search.js